import Tools from '@/components/tools/Tools.js'
import { find, isEmpty } from 'lodash'

import SinisterHeaderForms from './form/sinisterheader-form'
import SinisterHeaderModel from './model/sinisterheadermodel'
import InsuranceMixin from '@/store/module/insurance/mixin.js'
import RegulationMixin from '@/store/module/regulation/mixin'
// import { isArray } from 'util';

export default {
  name: 'SinisterHeader',
  mixins: [
    InsuranceMixin,
    RegulationMixin
  ],
  data () {
    return {
      data: SinisterHeaderModel,
      form: SinisterHeaderForms
    }
  },
  watch: {
    'regulation.id': function () {
      this.onEdit(this.regulation)
    }
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
    },
    onEdit (obj) {
      this.onClear()
      setTimeout(() => {
        this.fillData(obj)
      }, 1000)
    },
    fillData (obj) {
      if (this.hasRegulation) {
        this.form.sinisterCode.value = obj.sinisterCode
        this.form.sinisterVersion.value = obj.sinisterVersion

        if (obj.insurance !== null) {
          if (obj.insurance.name !== null) {
            this.form.insurance.value = obj.insurance.name
          }
        }

        this.form.sinisterCode.value = this.regulation.sinisterCode
        this.form.sinisterVersion.value = this.regulation.sinisterVersion

        if (!isEmpty(this.insurances.data)) {
          const insurance = find(this.insurances.data, { id: this.regulation.insuranceID })

          if (!insurance) {
            return false
          }

          this.form.insurance.value = insurance.name
        }

        if (this.regulation.insured != null) {
          if (this.regulation.insured.alias !== null) {
            this.form.insured.value = obj.insured.alias
          } else if (this.regulation.insured.name !== null) {
            this.form.insured.value = obj.insured.name
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/sinisterheader/sinisterheader.js